import { render } from "./ViewDeal.vue?vue&type=template&id=891efb9e"
import script from "./ViewDeal.vue?vue&type=script&lang=js"
export * from "./ViewDeal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__